import { c as _c } from "react/compiler-runtime";
import React from "react";
import { WaveWinnersDrop } from "./WaveWinnersDrop";
import type { ApiWave } from "@/generated/models/ApiWave";
import type { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import type { ApiWaveDecisionWinner } from "@/generated/models/ApiWaveDecisionWinner";
import { publicEnv } from "@/config/env";
import { getRenderableWaveDecisionWinners } from "@/helpers/waves/wave-decision.helpers";
import { CheckCircleIcon } from "@heroicons/react/24/outline";
interface WaveWinnersDropsProps {
  readonly wave: ApiWave;
  readonly onDropClick: (drop: ExtendedDrop) => void;
  readonly winners: ApiWaveDecisionWinner[];
  readonly isLoading?: boolean | undefined;
  readonly isApprovalWave?: boolean | undefined;
  readonly emptyMessage?: string | undefined;
}
export const WaveWinnersDrops: React.FC<WaveWinnersDropsProps> = t0 => {
  const $ = _c(28);
  const {
    wave,
    onDropClick,
    winners,
    isLoading: t1,
    isApprovalWave: t2,
    emptyMessage
  } = t0;
  const isLoading = t1 === undefined ? false : t1;
  const isApprovalWave = t2 === undefined ? false : t2;
  let t3;
  let t4;
  let t5;
  let t6;
  if ($[0] !== emptyMessage || $[1] !== isApprovalWave || $[2] !== isLoading || $[3] !== onDropClick || $[4] !== wave || $[5] !== winners) {
    t6 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const renderableWinners = getRenderableWaveDecisionWinners(winners);
      const invalidWinnerCount = winners.length - renderableWinners.length;
      const shouldShowInvalidWinnerWarning = invalidWinnerCount > 0 && publicEnv.NODE_ENV !== "production";
      const invalidWinnersMessage = invalidWinnerCount === 1 ? "Hidden 1 winner with missing drop data." : `Hidden ${invalidWinnerCount} winners with missing drop data.`;
      if (isLoading) {
        let t7;
        if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
          t7 = <div className="tw-h-0.5 tw-w-full tw-overflow-hidden tw-bg-iron-800"><div className="tw-h-full tw-w-full tw-animate-loading-bar tw-bg-indigo-400" /></div>;
          $[10] = t7;
        } else {
          t7 = $[10];
        }
        t6 = t7;
        break bb0;
      }
      if (!renderableWinners.length) {
        if (shouldShowInvalidWinnerWarning) {
          let t7;
          if ($[11] !== invalidWinnersMessage) {
            t7 = <p className="tw-rounded-md tw-border tw-border-amber-500/40 tw-bg-amber-500/10 tw-px-3 tw-py-2 tw-text-xs tw-text-amber-200">{invalidWinnersMessage}</p>;
            $[11] = invalidWinnersMessage;
            $[12] = t7;
          } else {
            t7 = $[12];
          }
          t6 = t7;
          break bb0;
        }
        if (emptyMessage) {
          let t7;
          if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
            t7 = <CheckCircleIcon className="tw-size-10 tw-text-iron-600" />;
            $[13] = t7;
          } else {
            t7 = $[13];
          }
          let t8;
          if ($[14] !== emptyMessage) {
            t8 = <div className="tw-flex tw-items-center tw-justify-center tw-px-4 tw-py-16"><div className="tw-flex tw-max-w-xs tw-flex-col tw-items-center tw-gap-4 tw-text-center">{t7}<p className="tw-mb-0 tw-text-base tw-font-medium tw-text-iron-300">{emptyMessage}</p></div></div>;
            $[14] = emptyMessage;
            $[15] = t8;
          } else {
            t8 = $[15];
          }
          t6 = t8;
          break bb0;
        }
        let t7;
        if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
          t7 = <></>;
          $[16] = t7;
        } else {
          t7 = $[16];
        }
        t6 = t7;
        break bb0;
      }
      t3 = "tw-space-y-3";
      if ($[17] !== invalidWinnersMessage || $[18] !== shouldShowInvalidWinnerWarning) {
        t4 = shouldShowInvalidWinnerWarning ? <p className="tw-rounded-md tw-border tw-border-amber-500/40 tw-bg-amber-500/10 tw-px-3 tw-py-2 tw-text-xs tw-text-amber-200">{invalidWinnersMessage}</p> : null;
        $[17] = invalidWinnersMessage;
        $[18] = shouldShowInvalidWinnerWarning;
        $[19] = t4;
      } else {
        t4 = $[19];
      }
      let t7;
      if ($[20] !== isApprovalWave || $[21] !== onDropClick || $[22] !== wave) {
        t7 = winner => <WaveWinnersDrop key={winner.drop.id} winner={winner} wave={wave} onDropClick={onDropClick} isApprovalWave={isApprovalWave} />;
        $[20] = isApprovalWave;
        $[21] = onDropClick;
        $[22] = wave;
        $[23] = t7;
      } else {
        t7 = $[23];
      }
      t5 = renderableWinners.map(t7);
    }
    $[0] = emptyMessage;
    $[1] = isApprovalWave;
    $[2] = isLoading;
    $[3] = onDropClick;
    $[4] = wave;
    $[5] = winners;
    $[6] = t3;
    $[7] = t4;
    $[8] = t5;
    $[9] = t6;
  } else {
    t3 = $[6];
    t4 = $[7];
    t5 = $[8];
    t6 = $[9];
  }
  if (t6 !== Symbol.for("react.early_return_sentinel")) {
    return t6;
  }
  let t7;
  if ($[24] !== t3 || $[25] !== t4 || $[26] !== t5) {
    t7 = <div className={t3}>{t4}{t5}</div>;
    $[24] = t3;
    $[25] = t4;
    $[26] = t5;
    $[27] = t7;
  } else {
    t7 = $[27];
  }
  return t7;
};